(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement-carousel__slide'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
      var dirs = {
        left: { a: 'X', s: 1 },
        right: { a: 'X', s: -1 },
        up: { a: 'Y', s: 1 },
        down: { a: 'Y', s: -1 }
      };
      this.dir = dirs[this.dataset.direction] || dirs.left;

      // Park non-active slides at the entry side for the chosen direction.
      for (var i = 0; i < this.slides.length; i++) {
        if (i !== this.index) {
          this.slides[i].style.transform = 'translate' + this.dir.a + '(' + (this.dir.s * 100) + '%)';
        }
      }

      var prev = this.querySelector('[data-ann-prev]');
      var next = this.querySelector('[data-ann-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, false); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1, true); this.restart(); });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this._onVisibility = () => { if (document.hidden) { this.stop(); } else { this.start(); } };
      document.addEventListener('visibilitychange', this._onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
    }

    go(target, forward) {
      var n = this.slides.length;
      target = ((target % n) + n) % n;
      if (target === this.index) return;

      var d = this.dir;
      var sign = forward ? d.s : -d.s;
      var current = this.slides[this.index];
      var upcoming = this.slides[target];

      // Place the upcoming slide at the entry edge without animating.
      upcoming.style.transition = 'none';
      upcoming.style.transform = 'translate' + d.a + '(' + (sign * 100) + '%)';
      upcoming.style.opacity = '0';
      void upcoming.offsetWidth;

      // Animate it into view.
      upcoming.style.transition = '';
      upcoming.classList.add('is-active');
      upcoming.style.transform = 'translate(0, 0)';
      upcoming.style.opacity = '1';

      // Send the current slide out to the opposite edge.
      current.classList.remove('is-active');
      current.style.transform = 'translate' + d.a + '(' + (-sign * 100) + '%)';
      current.style.opacity = '0';

      this.index = target;
    }

    start() {
      if (!this.autoplay || this.timer || this.slides.length < 2) return;
      this.timer = setInterval(() => this.go(this.index + 1, true), this.speed);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('announcement-carousel')) {
    customElements.define('announcement-carousel', AnnouncementCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-coming-soon"] && !Shopify.designMode) return;
  try {
    
  /* Mobile feature swiper: one dot per card, synced to the scroll position;
     tapping a dot scrolls to that card. Dots stay hidden while the cards fit
     without scrolling (desktop / tablet grid). */
  if (!customElements.get('cs-swiper')) {
    customElements.define(
      'cs-swiper',
      class CsSwiper extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-swiper-track]');
          this.dotsEl = this.querySelector('[data-swiper-dots]');
          if (!this.track || !this.dotsEl) return;
          this.cards = Array.from(this.track.children);
          this.cards.forEach((card, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'cs-swiper__dot';
            dot.setAttribute('aria-label', String(i + 1) + ' / ' + this.cards.length);
            dot.addEventListener('click', () => this.goTo(i));
            this.dotsEl.appendChild(dot);
          });
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        offset(card) {
          const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          return card.offsetLeft - this.track.offsetLeft - pad;
        }

        goTo(i) {
          const card = this.cards[i];
          if (!card) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: this.offset(card), behavior: reduce ? 'auto' : 'smooth' });
        }

        update() {
          const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
          this.dotsEl.hidden = !scrollable || this.cards.length < 2;
          if (this.dotsEl.hidden) return;
          const left = this.track.scrollLeft;
          let active = 0;
          this.cards.forEach((card, i) => {
            if (Math.abs(this.offset(card) - left) < Math.abs(this.offset(this.cards[active]) - left)) active = i;
          });
          if (left + this.track.clientWidth >= this.track.scrollWidth - 2) active = this.cards.length - 1;
          this.dotsEl.querySelectorAll('.cs-swiper__dot').forEach((dot, i) => {
            dot.setAttribute('aria-current', String(i === active));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 998.98px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mega-menu__content').forEach(menu => {
      const promoWrapper = menu.querySelector('[data-mega-menu-promo]');
      if (!promoWrapper) return;

      const promoCard = promoWrapper.querySelector('.mega-menu__promo-card');
      const promoImage = promoWrapper.querySelector('.mega-menu__promo-image');
      const promoPlaceholder = promoWrapper.querySelector('.mega-menu__promo-placeholder');
      const promoHeading = promoWrapper.querySelector('.mega-menu__promo-heading');

      const originalImg = promoCard.dataset.originalImage;
      const originalTitle = promoCard.dataset.originalTitle;

      menu.querySelectorAll('.mega-menu__link').forEach(link => {
        link.addEventListener('mouseenter', () => {
          const hoverImg = link.dataset.megaMenuImage;
          const hoverTitle = link.dataset.megaMenuTitle;

          if (hoverImg) {
            if (promoPlaceholder) promoPlaceholder.classList.add('is-hidden');
            if (promoImage) {
              promoImage.classList.add('is-hidden');
              setTimeout(() => {
                promoImage.src = hoverImg;
                promoImage.srcset = hoverImg;
                promoImage.classList.remove('is-hidden');
              }, 50);
            }
            if (promoHeading) promoHeading.textContent = hoverTitle;
          } else {
            // Revert back when hovering over a link that doesn't have an image
            if (promoImage) promoImage.classList.add('is-hidden');
            setTimeout(() => {
                if (originalImg) {
                  if (promoImage) {
                    promoImage.src = originalImg;
                    promoImage.srcset = originalImg;
                    promoImage.classList.remove('is-hidden');
                  }
                } else {
                  if (promoPlaceholder) promoPlaceholder.classList.remove('is-hidden');
                }
                if (promoHeading) promoHeading.textContent = originalTitle;
            }, 50);
          }
        });
      });

      const columnGroups = menu.querySelectorAll('.mega-menu__column-group');
      columnGroups.forEach(group => {
        group.addEventListener('mouseleave', (e) => {
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && (relatedTarget.closest('.mega-menu__column-group') || relatedTarget.closest('.mega-menu__promo'))) {
                return;
            }

            if (promoImage) promoImage.classList.add('is-hidden');
            setTimeout(() => {
                if (originalImg) {
                  if (promoImage) {
                    promoImage.src = originalImg;
                    promoImage.srcset = originalImg;
                    promoImage.classList.remove('is-hidden');
                  }
                } else {
                  if (promoPlaceholder) promoPlaceholder.classList.remove('is-hidden');
                }
                if (promoHeading) promoHeading.textContent = originalTitle;
            }, 50);
        });
      });
      
      menu.addEventListener('mouseleave', () => {
          if (promoImage) promoImage.classList.add('is-hidden');
          setTimeout(() => {
              if (originalImg) {
                if (promoImage) {
                  promoImage.src = originalImg;
                  promoImage.srcset = originalImg;
                  promoImage.classList.remove('is-hidden');
                }
              } else {
                if (promoPlaceholder) promoPlaceholder.classList.remove('is-hidden');
              }
              if (promoHeading) promoHeading.textContent = originalTitle;
          }, 50);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-description-reveal')) {
    customElements.define('collection-description-reveal', class CollectionDescriptionReveal extends HTMLElement {
      constructor() {
        super();
        this.description = this.querySelector('.collection-hero__description');
        this.button = this.querySelector('.collection-hero__see-more');
        if (!this.description || !this.button) return;

        this.desktopTruncate = this.dataset.desktopTruncate === 'true';
        this.desktopLines = parseInt(this.dataset.desktopLines, 10) || 2;
        this.mobileLines = parseInt(this.dataset.mobileLines, 10) || 2;
        // Mobile is always truncated; desktop follows the schema toggle.
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.collapsedHeight = 0;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.mobileQuery.addEventListener('change', this.reset.bind(this));

        const observer = new ResizeObserver(() => this.measure());
        observer.observe(this);
      }

      // Truncation is active on mobile always, on desktop only if the schema says so
      get truncateActive() {
        return this.mobileQuery.matches ? true : this.desktopTruncate;
      }

      get lines() {
        return String(this.mobileQuery.matches ? this.mobileLines : this.desktopLines);
      }

      // Called when crossing the mobile/desktop breakpoint: collapse and re-measure
      reset() {
        this.description.classList.remove('is-expanded');
        this.description.style.maxHeight = '';
        this.button.textContent = this.button.dataset.more;
        this.button.setAttribute('aria-expanded', 'false');
        this.measure();
      }

      measure() {
        // Desktop with truncation off: show the full text, no button
        if (!this.truncateActive) {
          this.description.style.webkitLineClamp = 'unset';
          this.description.style.lineClamp = 'unset';
          this.description.style.display = 'block';
          this.description.style.maxHeight = 'none';
          this.button.classList.add('hidden');
          return;
        }

        if (this.description.classList.contains('is-expanded')) return;

        this.description.style.display = '-webkit-box';
        this.description.style.webkitLineClamp = this.lines;
        this.description.style.lineClamp = this.lines;
        this.description.style.maxHeight = 'none';

        const currentHeight = this.description.clientHeight;
        const totalHeight = this.description.scrollHeight;

        if (totalHeight > currentHeight + 2) {
          this.button.classList.remove('hidden');
          this.collapsedHeight = currentHeight;
          this.description.style.maxHeight = this.collapsedHeight + 'px';
        } else {
          this.button.classList.add('hidden');
          this.description.style.maxHeight = 'none';
        }
      }

      toggle() {
        const isExpanded = this.description.classList.contains('is-expanded');

        if (!isExpanded) {
          this.description.classList.add('is-expanded');
          this.description.style.webkitLineClamp = 'unset';
          this.description.style.lineClamp = 'unset';
          this.description.style.display = 'block';
          requestAnimationFrame(() => {
            this.description.style.maxHeight = this.description.scrollHeight + 'px';
          });
        } else {
          this.description.style.maxHeight = this.collapsedHeight + 'px';
          const onTransitionEnd = (e) => {
            if (e.propertyName === 'max-height') {
              this.description.classList.remove('is-expanded');
              this.description.style.webkitLineClamp = this.lines;
              this.description.style.lineClamp = this.lines;
              this.description.style.display = '-webkit-box';
              this.description.removeEventListener('transitionend', onTransitionEnd);
            }
          };
          this.description.addEventListener('transitionend', onTransitionEnd);
        }

        this.button.textContent = !isExpanded ? this.button.dataset.less : this.button.dataset.more;
        this.button.setAttribute('aria-expanded', !isExpanded);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hh:recently-viewed';
    var SECTION = 'recently-viewed-product';

    function cardUrl(url) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION;
    }

    function fetchCard(url) {
      var ck = 'hh:rvcard:' + url;
      try {
        var cached = sessionStorage.getItem(ck);
        if (cached !== null) return Promise.resolve(cached);
      } catch (e) {}
      return fetch(cardUrl(url))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var el = new DOMParser().parseFromString(text, 'text/html').querySelector('.rv-card-render');
          var html = el ? el.innerHTML.trim() : '';
          try { sessionStorage.setItem(ck, html); } catch (e) {}
          return html;
        })
        .catch(function () { return ''; });
    }

    function load(section, items) {
      var ul = section.querySelector('[data-rv-track]');
      if (!ul) return;
      items.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'grid__item';
        ul.appendChild(li);
        fetchCard(p.url).then(function (html) {
          if (html) {
            li.innerHTML = html;
          } else if (li.parentNode) {
            li.parentNode.removeChild(li);
          }
        });
      });
    }

    function init(section) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
      if (!Array.isArray(list)) list = [];

      var currentId = null;
      var pi = document.querySelector('product-info');
      if (pi && pi.dataset.productId) currentId = parseInt(pi.dataset.productId, 10);

      var max = parseInt(section.dataset.max, 10) || 4;
      var items = list.filter(function (p) {
        return p && p.id && p.url && p.id !== currentId;
      }).slice(0, max);
      var note = section.querySelector('[data-rv-note]');

      if (items.length) {
        section.style.display = '';
        if (note) note.hidden = true;
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries, obs) {
            if (entries[0].isIntersecting) {
              obs.disconnect();
              load(section, items);
            }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(section);
        } else {
          load(section, items);
        }
      } else if (section.dataset.designMode === 'true') {
        if (note) note.hidden = false;
        section.style.display = '';
      } else {
        section.style.display = 'none';
      }
    }

    function initAll() {
      document.querySelectorAll('[data-recently-viewed]').forEach(function (s) { init(s); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rug-size-guide"]) return;
  try {
    
  (function () {
    function activate(root, index) {
      var tabs = root.rsgTabs || [];
      var panels = root.rsgPanels || [];
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      root.rsgActive = index;
    }

    function build(root) {
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rsg-panel]'));
      if (!panels.length) return;

      var existing = root.querySelector('.rsg__tablist');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var list = document.createElement('div');
      list.className = 'rsg__tablist';
      list.setAttribute('role', 'tablist');

      var tabs = panels.map(function (panel, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rsg-tab';
        btn.setAttribute('role', 'tab');
        if (panel.id) {
          btn.id = panel.id + '-tab';
          btn.setAttribute('aria-controls', panel.id);
          panel.setAttribute('aria-labelledby', btn.id);
        }

        var frame = document.createElement('span');
        frame.className = 'rsg-tab__frame';
        var thumb = panel.querySelector('.rsg-panel__thumb');
        var media = thumb ? thumb.querySelector('.rsg-tab__img, .rsg-tab__icon, .placeholder-svg') : null;
        if (media) frame.appendChild(media.cloneNode(true));

        var label = document.createElement('span');
        label.className = 'rsg-tab__label';
        label.textContent = panel.getAttribute('data-rsg-label') || 'Size ' + (i + 1);

        var count = document.createElement('span');
        count.className = 'rsg-tab__count';
        var n = panel.querySelectorAll('.rsg-card').length;
        count.textContent = n + (n === 1 ? ' option' : ' options');

        var line = document.createElement('span');
        line.className = 'rsg-tab__line';
        line.setAttribute('aria-hidden', 'true');

        btn.appendChild(frame);
        btn.appendChild(label);
        if (n > 0) btn.appendChild(count);
        btn.appendChild(line);

        btn.addEventListener('click', function () {
          activate(root, i);
        });
        btn.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = i + 1 >= tabs.length ? 0 : i + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = i - 1 < 0 ? tabs.length - 1 : i - 1;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = tabs.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          activate(root, next);
          if (root.rsgTabs[next]) root.rsgTabs[next].focus();
        });

        list.appendChild(btn);
        return btn;
      });

      root.rsgTabs = tabs;
      root.rsgPanels = panels;
      root.insertBefore(list, root.firstChild);
      root.classList.add('is-enhanced');

      var start = root.rsgActive && root.rsgActive < panels.length ? root.rsgActive : 0;
      activate(root, start);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rsg-root]').forEach(function (root) {
        build(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!event.target.closest) return;
      var panel = event.target.closest('[data-rsg-panel]');
      if (!panel) return;
      var root = panel.closest('[data-rsg-root]');
      if (!root || !root.rsgPanels) return;
      var idx = root.rsgPanels.indexOf(panel);
      if (idx > -1) activate(root, idx);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* Whole-slide link: buttons and other controls inside the slide keep their own behaviour */
  document.addEventListener('click', (event) => {
    const slide = event.target.closest('.slideshow__slide[data-slide-link]');
    if (!slide) return;
    if (event.target.closest('a, button, select, input, label, [role="link"], [role="button"]')) return;
    if (window.getSelection && window.getSelection().toString()) return;
    window.location.href = slide.dataset.slideLink;
  });

  } catch(e) { console.error(e); }
})();
})();
